<template>
	<transition name="fade" class="fade">
		<div class="loading-box fixed-100" v-show="show">
			<div class="msg-dialog">
				<p class="icon"></p>
				<p v-html="text"></p>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'toastComponent',
		props: {
			text: String,
			visible: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				show: this.visible
			}
		}
	}
</script>

<style scoped>
	.fade-enter-active, .fade-leave-active {
		transition: opacity 1s
	}
	.fade-enter, .fade-leave-to {
		opacity: 0
	}
	.loading-box {
		z-index: 9999
	}
	.loading-box  .msg-dialog {
		width: 2rem;
		height: 2rem;
		border-radius: 0.08rem;
		background: rgba(0, 0, 0, 0.7);
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		color: white;
	}
	.loading-box .msg-dialog .icon{
		width: .8rem;
		height: .8rem;
		background: url("../../../assets/images/ico/ico-loading.png") no-repeat;
		background-size: 100% 100%;
		animation: loadingAnimation 0.8s linear infinite;
        top: .1rem;
        position: relative;
	}
	@keyframes loadingAnimation {
		0% {transform: rotate(0deg);}
		100% {transform: rotate(360deg);}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/loading/loading.vue